export default function() {

  const mapHTML = `
    <div class="onc-map__directions map__directions">
      <div class="onc-map__directions-box map__directions-box">
        <img data-src="${FULLCLIENTTHEMEPATH}images/onc_map-logo.png" class="lozad" alt="Oncenter">
        <span>MAILING ADDRESS</span>
        <span>800 South State St. <br>Syracuse, NY 13202</span>
      </div>
    </div>
    <div class="onc-map map-inner">
      <div class="onc-map-wrapper map-wrapper">
        <div class="onc-map__links">
          <a href="https://goo.gl/maps/y6wovvUKeNfmhBLJ7" target="_blank" aria-label="Civic Center Theaters - Get Directions"></a>
          <a href="https://goo.gl/maps/F3Bn588AD7yyK5pP6" target="_blank" aria-label="War Memorial Arena - Get Directions"></a>
          <a href="https://goo.gl/maps/nkStTKtxBuJsdfs76" target="_blank" aria-label="Convention Center - Get Directions"></a>
        </div>
        <img 
          data-src="${FULLCLIENTTHEMEPATH}images/onc_map-center.png"
          class="onc-map__img-desktop map__img-desktop lozad" 
          alt="Oncenter Map">
        <img 
          data-src="${FULLCLIENTTHEMEPATH}images/onc_map-center-m.png"
          class="onc-map__img-mobile map__img-mobile lozad" 
          alt="Oncenter Map">       
      </div>    
    </div>
  `;

  $('#oncenter__map').append(mapHTML);
  $('#amphitheater__map').remove();

}